<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="searchText" ttShowClearButton></tt-input>
            <tt-button-goto ttText="positions_new" ttGoto="position" [ttGotoParms]="{ argtype: setting.argtype, argvalue: setting.argvalue, position_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListPositions" [ttFilter]="searchText"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <div class="col-xs-12 col-md-4 p-5">
                <tt-card>
                    <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="searchText" ttShowClearButton></tt-input>
                </tt-card>

                <tt-list [ttData]="itemsListPositions" [ttFilter]="searchText"></tt-list>
            </div>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="positions_new" ttGoto="position" [ttGotoParms]="{ argtype: setting.argtype, argvalue: setting.argvalue, position_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>
    </div>
</tt-page>
